import { ExplorerAssistantConversationState } from '@om1/platform-assistant-ui'
import { explorerAssistantConversationActions } from '@om1/platform-assistant-ui/src/state/explorer-assistant-conversation-actions'
import { withRouter } from '@om1/platform-routing'
import { trackingActions } from '@om1/platform-tracking'
import { connectRedux } from '@om1/platform-utils'
import { cohortBlocksEditActions, cohortCommonActions, cohortEditActions, CohortState } from '../../../state'
import { CohortEditComponent } from './CohortEditComponent'

export function createCohortEditComponent<
    TState extends { cohort: CohortState; explorerAssistantConversation: ExplorerAssistantConversationState }
>() {
    return connectRedux(
        withRouter(CohortEditComponent, { namespace: 'cohorts', dataFetchAction: 'cohortGet' }),
        (state: TState) => ({
            cohort: state.cohort.edit.base.cohort,
            tree: state.cohort.edit.blocks.tree,
            cohortLoading: state.cohort.edit.base.ui.loading,
            lastSavedBlocks: state.cohort.edit.blocks.ui.lastSavedBlocks,
            criteriaDialog: state.cohort.edit.blocks.ui.criteriaDialog,
            criteriaRelationDialog: state.cohort.edit.blocks.ui.criteriaRelationDialog,
            occurrenceEditDialog: state.cohort.edit.blocks.ui.occurenceEditDialog,
            specialtyEditDialog: state.cohort.edit.blocks.ui.specialtyEditDialog,
            recencyEditDialog: state.cohort.edit.blocks.ui.recencyEditDialog,
            patientAgeEditDialog: state.cohort.edit.blocks.ui.patientAgeEditDialog,
            followUpLengthEditDialog: state.cohort.edit.blocks.ui.followUpLengthEditDialog,
            observationScoreEditDialog: state.cohort.edit.blocks.ui.observationScoreEditDialog,
            labNumericQualifierEditDialog: state.cohort.edit.blocks.ui.labNumericQualifierEditDialog,
            dragState: state.cohort.edit.blocks.ui.dragging,
            updateLoading: state.cohort.edit.base.ui.cohortUpdateLoading,
            sizeLoading: state.cohort.common.ui.cohortSizeLoading[state.cohort.edit.base.cohort.id],
            refLabels: state.cohort.edit.blocks.ui.refLabels,
            conversations: state.explorerAssistantConversation?.conversations ?? []
        }),
        { ...cohortEditActions, ...cohortBlocksEditActions, ...cohortCommonActions, ...trackingActions, ...explorerAssistantConversationActions }
    )
}

export type CohortEdit = ReturnType<typeof createCohortEditComponent>
